export default "/storefront/client/images/rightarrow.png";